/**
 *
 * LocationMarkers
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { withLeaflet } from 'react-leaflet';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import withRest from 'containers/Rest/withRest';
import withLocations from 'containers/Locations/withEntity';
import withUiControl from 'containers/UiControl/withUiControl';
import LocationMarker from './LocationMarker';

/* eslint-disable react/prefer-stateless-function */
class LocationMarkers extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadLocations = debounce(this.loadLocations, 500).bind(this);
  }

  componentDidMount() {
    const { leaflet } = this.props;
    this.loadLocations();
    leaflet.map.on('moveend', this.loadLocations);
  }

  componentWillUnmount() {
    const { leaflet } = this.props;
    leaflet.map.off('moveend', this.loadLocations);
  }

  componentDidUpdate(prevProps) {
    const { showLocations } = this.props;
    if (showLocations && !prevProps.showLocations) {
      this.loadLocations();
    }
  }

  loadLocations() {
    const { apiList, leaflet, showLocations } = this.props;
    if (showLocations) {
      apiList({ bounds: leaflet.map.getBounds().toBBoxString() });
    }
  }

  render() {
    const { locations, showLocations, params } = this.props;
    if (!showLocations || !locations.list || locations.list.length === 0) {
      return null;
    }
    const dimmed = Boolean(params.routeId || params.clubId);
    return locations.list.map(id => (
      <LocationMarker key={id} dimmed={dimmed} loc={locations[id]} />
    ));
  }
}

LocationMarkers.propTypes = {
  apiList: PropTypes.func.isRequired,
  locations: PropTypes.object,
  leaflet: PropTypes.object.isRequired,
  showLocations: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
};

export default compose(
  withLocations,
  withRest,
  withLeaflet,
  withUiControl('showLocations'),
)(LocationMarkers);
